if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.sectionId = this.dataset.section;
    }

    connectedCallback() {
      this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
      this.footerElement = document.querySelector('footer');
      this.stickyAtcVariantInput = this.querySelector('.product-variant-id');        

      window.addEventListener("scroll", this.handleScroll);
      document.body.addEventListener('change', this.handleVariantChange);
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
      document.body.removeEventListener('change', this.handleVariantChange);
    }

    getAbsoluteTop(element) {
      let top = 0;
      while (element) {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      }
      return top;
    }

    handleScroll() {
      const targetTopPosition = this.getAbsoluteTop(this.targetElement);
      const footerTopPosition = this.getAbsoluteTop(this.footerElement);
      const isTargetElementOutOfView = targetTopPosition < window.scrollY;
      const isFooterInView = window.scrollY + window.innerHeight > footerTopPosition;

      if (isTargetElementOutOfView && !isFooterInView) {
        this.classList.add('show');
      } else {
        this.classList.remove('show');
      }
    }

    
    updateStickyATCOption(optionName, optionValue) {
      let displayName = optionName;

      const bracketMatch = optionName.match(/options\[(.+)\]/);
      if (bracketMatch && bracketMatch[1]) {
        displayName = bracketMatch[1];
      } 
      else if (/^option[-_]?\d+/i.test(optionName)) {
        const optionIndex = optionName.match(/\d+/)?.[0] || '';
        displayName = `Option ${optionIndex}`;
      }
      
      displayName = displayName.trim();
      const escapedName = CSS.escape(displayName);
      
      console.log('Updating sticky option:', displayName, optionValue);
      
      const optionDisplay = this.querySelector(
        `.selected-variant-option[data-option-name="${escapedName}"]`
      );

      if (optionDisplay) {
        optionDisplay.textContent = `${displayName}: ${optionValue}`;
      }
      
      if (this.stickyAtcVariantInput) {
        const selectedVariantInput =
        document.querySelector(
          `#MainProduct-${this.sectionId} input[name="id"]:checked`
        ) ||
        document.querySelector(
            `#MainProduct-${this.sectionId} select[name="id"]`
          );
          
          if (selectedVariantInput) {
            this.stickyAtcVariantInput.value = selectedVariantInput.value;
        }
      }
    }
    
    handleVariantChange(event) {
      const target = event.target;
      console.log('ggg', target.tagName, target.name);
  
      const productSection = target.closest(`#MainProduct-${this.sectionId}`);
      console.log('sss', productSection);
  
      if (!productSection) return;
  
      if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
        const optionName = target.name;
        const optionValue =
          target.tagName === 'INPUT'
            ? target.value
            : target.options[target.selectedIndex].textContent;
  
        console.log('optionName:', optionName, 'optionValue:', optionValue);
  
        this.updateStickyATCOption(optionName, optionValue);
      }
    }
    
  }
  
  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
